import styled from 'styled-components';
import { CardHeader as MuiCardHeader } from '@material-ui/core';

export const CardHeader = styled(MuiCardHeader)`
  background-color: ${({ props, theme }) =>
    props?.disabled === true ? theme.palette.background.dark : theme.palette.background.cardHeader};
  color: ${({ props, theme }) =>
    props?.disabled ? theme.palette.text.secondary : theme.palette.primary.main};
`;
